import {
  GET_TEXTS,
  SET_GLOBAL_ERROR
} from '@/store/actions.type'

import {
  SET_TEXTS
} from '@/store/mutations.type'

import Vue from 'vue'
import axios from 'axios'
import api from '@/api'

const state = {
  texts: []
}

const getters = {
  texts(state) {
    return state.texts
  },
  text(state) {
    return (key, placeholders = {}) => {
      let text = state.texts[key]
      for (let name in placeholders) {
        text = text.replace('{{' + name + '}}', placeholders[name])
      }
      return text
    }
  }
}

export const actions = {
  async [GET_TEXTS](context) {
    return await axios({
      method: 'GET',
      url: api.webview.getTexts.url()
    }).then(response => {
      context.commit(SET_TEXTS, {texts: response.data})
    }).catch(error => {
      context.dispatch(SET_GLOBAL_ERROR, {error: error, defaultError: new Vue().text('error')})
    })
  }
}

export const mutations = {
  [SET_TEXTS](state, data) {
    state.texts = data.texts
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
